var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { CardName, Subtext, Text, Title, WithCardAction } from '../components';
import { fixedForwardRef } from '../fixedForwardRef';
function StippledCardWithForwardRef(props, ref) {
    var className = props.className, condensed = props.condensed, img = props.img, noMargin = props.noMargin, rightImg = props.rightImg, children = props.children, rest = __rest(props, ["className", "condensed", "img", "noMargin", "rightImg", "children"]);
    return (React.createElement(WithCardAction, __assign({ baseClassName: "ffe-stippled-card", className: classNames('ffe-stippled-card', { 'ffe-stippled-card--condensed': condensed }, { 'ffe-stippled-card--no-margin': noMargin }, className) }, rest, { ref: ref }), function (_a) {
        var CardAction = _a.CardAction;
        return (React.createElement(React.Fragment, null,
            img && (React.createElement("div", { className: classNames('ffe-stippled-card__img', {
                    'ffe-stippled-card__img--icon': (img === null || img === void 0 ? void 0 : img.type) === 'icon',
                }), "aria-hidden": (img === null || img === void 0 ? void 0 : img.type) === 'icon' }, img === null || img === void 0 ? void 0 : img.element)),
            React.createElement("div", { className: 'ffe-stippled-card__content' }, typeof children === 'function'
                ? children({
                    CardName: CardName,
                    Title: Title,
                    Text: Text,
                    Subtext: Subtext,
                    CardAction: CardAction,
                })
                : children),
            rightImg && (React.createElement("div", { className: classNames('ffe-stippled-card__img', {
                    'ffe-stippled-card__img--icon': (rightImg === null || rightImg === void 0 ? void 0 : rightImg.type) === 'icon',
                }), "aria-hidden": (rightImg === null || rightImg === void 0 ? void 0 : rightImg.type) === 'icon' }, rightImg === null || rightImg === void 0 ? void 0 : rightImg.element))));
    }));
}
export var StippledCard = fixedForwardRef(StippledCardWithForwardRef);
